var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Next",
    clipPath: "url(#clip0_4831_14646)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.3156 9.68039C11.4089 9.68039 11.5008 9.64483 11.5719 9.57372L15.8697 5.27594C16.0119 5.13372 16.0119 4.90409 15.8697 4.76335L11.5719 0.464089C11.4297 0.321866 11.2 0.321866 11.0593 0.464089C10.9171 0.606311 10.9171 0.83594 11.0593 0.976681L15.1008 5.01816L11.0593 9.05964C10.9171 9.20187 10.9171 9.4315 11.0593 9.57224C11.1304 9.64483 11.2223 9.68039 11.3156 9.68039Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.51702 15.641H12.7407C12.9407 15.641 13.1037 15.478 13.1037 15.278C13.1037 15.078 12.9407 14.915 12.7407 14.915H5.51702C2.88887 14.915 0.749608 12.7773 0.749608 10.1476C0.749608 7.51948 2.88887 5.38022 5.51702 5.38022H14.8029C15.0029 5.38022 15.1659 5.21726 15.1659 5.01726C15.1659 4.81726 15.0029 4.6543 14.8029 4.6543H5.51702C4.77627 4.6543 4.05627 4.79948 3.37924 5.08541C2.72442 5.36244 2.13776 5.758 1.63257 6.2617C1.12739 6.76541 0.73183 7.35356 0.454793 8.00837C0.168867 8.68689 0.0236816 9.40689 0.0236816 10.1476C0.0236816 10.8884 0.168867 11.6084 0.454793 12.2854C0.73183 12.9402 1.12739 13.5269 1.63109 14.0321C2.13479 14.5373 2.72294 14.9328 3.37776 15.2099C4.05627 15.4958 4.77479 15.641 5.51702 15.641Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4831_14646"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/Next.8105a7b952e3593ea96bb99bf18ce43c.svg";
export { ForwardRef as ReactComponent };